// extracted by mini-css-extract-plugin
export default {"inputWrapper":"Input-module__inputWrapper___AmiM6","input":"Input-module__input___Os6f1","error":"Input-module__error___XvxSg","nofocus":"Input-module__nofocus___z5NZw"};